import React, { useState } from 'react'

import { Location, LocationRadio } from 'components/BillingLocationSelector'
import EditPostContainer, {
  CommonContainerProps
} from 'containers/EditPostContainer'
import LighterText from 'components/Text/Lighter'

import { Container, AddIcon, AddLocation } from './OfficeLocation.style'
import ErrorText from 'components/Text/ErrorText'

interface SelectionType {
  location: Location
}

interface OfficeLocationProps extends CommonContainerProps<SelectionType> {
  locations: Array<Location>
  initLocation?: Location
  onAddLocation: () => any
}

export default function OfficeLocation({
  initLocation,
  locations,
  onNext,
  onAddLocation,
  ...props
}: OfficeLocationProps) {
  const [selectedLocation, setSelectedLocation] = useState(
    initLocation as Location
  )

  return (
    <EditPostContainer
      title='Office Location'
      progressValue={24}
      {...props}
      onNext={() => {
        return onNext({
          location: selectedLocation
        })
      }}
      isNextAvailable={!!selectedLocation}
    >
      <Container>
        <LighterText>Location</LighterText>
        {!selectedLocation && (
          <ErrorText>You must select a location to continue</ErrorText>
        )}

        <LocationRadio
          hideCardsInfo
          locations={locations}
          onSetLocation={setSelectedLocation}
          selectedLocation={selectedLocation}
        />
        <AddLocation onClick={onAddLocation}>
          <AddIcon />
          Add New Office Location
        </AddLocation>
      </Container>
    </EditPostContainer>
  )
}
